module.exports = __webpack_public_path__ + "static/media/na.7dd0f798.svg";